import React from "react";

import { makeStyles } from "@material-ui/core";

import Appbar from "../../components/Appbar";
// import Sugeridos from "../../components/Sugeridos";
import Albuns from "../../components/Albuns";
import Footer from "../../components/Footer";
// import Pesquisa from "../../components/Pesquisa";
// import PesquisaM from "../../components/PesquisaM";
import Header from "../../components/Header";
import ParceirosF from "../../components/ParceirosF";

export default function Galeria() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Header />
      <Appbar />
      {/* <div style={{ top: "21.6vw", position: "sticky", zIndex: "1000" }}>
        <PesquisaM />
      </div> */}
      <div className={classes.content}>
        <div className={classes.limit}>
          {/* <Sugeridos /> */}
          {/* <Pesquisa /> */}
          <Albuns />
        </div>
      </div>
      <ParceirosF />
      <Footer />
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexDirection: "column",
    backgroundColor: theme.colors.white,
    display: "flex",
    height:'100vh'
  },
  content: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
    paddingRight: "5px",
    paddingLeft: "5px",
  },
  paginas: {},
  limit: {
    width: "100%",
    maxWidth: "1376px",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
  },
}));
